module.exports = __webpack_public_path__ + "assets/squad.6a8450e5.svg";